var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ce0024;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.318 -0.209)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(0.318 0.209)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.986 16.601)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.26 5.499)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M516.785,739.269v6.567a.294.294,0,0,1-.294.294H513.1a.294.294,0,0,1-.294-.294v-6.107c0-1.607-.574-2.7-2.014-2.7a2.176,2.176,0,0,0-2.041,1.455,2.726,2.726,0,0,0-.132.969v6.388a.294.294,0,0,1-.294.294h-3.388a.293.293,0,0,1-.294-.294c.007-1.626.042-9.516.007-11.372a.292.292,0,0,1,.294-.3h3.382a.293.293,0,0,1,.294.293v1.4c-.008.013-.02.026-.026.039h.026v-.039a3.949,3.949,0,0,1,3.585-1.976c2.617,0,4.579,1.709,4.579,5.383Zm-18.023,6.861h3.389a.294.294,0,0,0,.294-.294V734.46a.293.293,0,0,0-.294-.293h-3.389a.293.293,0,0,0-.293.293v11.376A.294.294,0,0,0,498.761,746.13Z",
    transform: "translate(-498.468 -733.886)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M502.3,727.071a2.129,2.129,0,1,1-2.129-2.129A2.129,2.129,0,0,1,502.3,727.071Z",
    transform: "translate(-498.045 -724.942)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinicon);
export default __webpack_public_path__ + "static/media/linkedinicon.57251ca2ce46b1b843da89ada7b412f5.svg";
export { ForwardRef as ReactComponent };